import { Component } from "react";

class FormElement extends Component {
    constructor(props){
        super (props);

        this.state = {
            isValid: null
        };
    }

    isValid() {
        return this.state.isValid;
    }

    checkValid(e) {
        let isValid = e.target.checkValidity();
        if (!e.target.required &&
            e.target.hasOwnProperty('value') &&
            e.target.value.length === 0) {
            alert(123123);
            isValid = false;
        }

        this.setState({
            isValid: isValid
        });

        return isValid;
    }
}

export default FormElement;


